import AttachmentResource from '@/api/resources/attachment/attachmentResource'
import { BASE_URL } from '@/api/api'
import { auth } from '@/api/auth'

class ComplementaryAttachmentService extends AttachmentResource {
    async addAttachment(laboratoryId, caseId, complementaryId, attachmentTypeId, file, thumbnailBytes) {
        let thumbnail

        if (thumbnailBytes) {
            thumbnail = this.base64ToBlob(thumbnailBytes, file.name)
        } else {
            let generatedThumbnailBytes = await this.thumbnailifyFromBlob(file)
            thumbnail = this.base64ToBlob(generatedThumbnailBytes, file.name)
        }

        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('atyId', attachmentTypeId)

        if (thumbnail) {
            formData.append('thumbnail', thumbnail, file.name)
        }

        const response = await this.axios.post(
            `/common/laboratories/${laboratoryId}/cases/${caseId}/complementary/${complementaryId}/attachments`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })
        return response.data
    }

    async getAttachmentsForAttachmentType(laboratoryId, caseId, complementaryId, attachmentTypeId) {
        const params = { attachmentTypeId }
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/complementary/${complementaryId}/attachments`, { params })
        return response.data
    }

    async getFile(laboratoryId, caseId, complementaryId, attachmentId) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/complementary/${complementaryId}/attachments/${attachmentId}`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }).then(response => response.data)
    }

    async patchAttachment(laboratoryId, caseId, complementaryId, attachmentId, request) {
        const response = await this.axios.patch(`/common/laboratories/${laboratoryId}/cases/${caseId}/complementary/${complementaryId}/attachments/${attachmentId}`, request)
        return response.data
    }

    getUrlForAttachment(laboratoryId, caseId, complementaryId, attachmentId) {
        return `${BASE_URL}/common/laboratories/${laboratoryId}/cases/${caseId}/complementary/${complementaryId}/attachments/${attachmentId}?authenticationToken=${auth.token}`
    }

    async deleteAttachment(laboratoryId, caseId, complementaryId, attachmentId) {
        const response = await this.axios.delete(`/common/laboratories/${laboratoryId}/cases/${caseId}/complementary/${complementaryId}/attachments/${attachmentId}`)
        return response.data
    }
}

export default new ComplementaryAttachmentService()
